import CurrencyTypeAhead from './CurrencyTypeAhead';

export default CurrencyTypeAhead;
